module.exports = "https://static.wanderu.com/ui-react/_next/static/media/cnn-money.55c1ebb9.png";